import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// components
import Button from "../../Button/Button";

// styles
import * as styles from "./HealthyMetabolism.module.css";

const HealthyMetabolismComponent = ({
  ctaText = "",
  ctaVariant = "",
  redirectionLink = "",
  onCtaClick = () => {},
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className={styles.healthyMetabolismWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        <div className={styles.healthyMetabolismContent}>
          <div className={styles.healthyMetabolismImage}>
            <StaticImage
              src="../../../images/aboutProgram/healthy_circle.png"
              alt="Twin Health Banner"
              placeholder="blurred"
              quality={90}
              loading="lazy"
            />
          </div>
          <div className={styles.healthyMetabolismText}>
            <h1>The power of a healthy metabolism</h1>
            <p>
              Your metabolism turns food into energy for everything your body
              does, from breathing and circulating blood to repairing tissues
              and maintaining essential processes that keep you functioning well
              daily.
            </p>
            <p>
              Understanding your metabolism is essential for managing lifestyle
              diseases like type 2 diabetes, obesity, dyslipidemia, hypertension
              and ovarian cysts, while also helping prevent serious long-term
              complications including stroke, cardiovascular strain and
              progressive organ-related metabolic damage.
            </p>
            <Button
              text={ctaText}
              href={redirectionLink}
              variant={ctaVariant}
              onClick={() => {
                onCtaClick(ctaText);
              }}
              btnClass={styles.healthyMetabolismBtn}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthyMetabolismComponent;
